/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlPasswordRequest
 */
export interface ControlPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlPasswordRequest
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPasswordRequest
     */
    u?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlPasswordRequest
     */
    jwt: string;
}

/**
 * Check if a given object implements the ControlPasswordRequest interface.
 */
export function instanceOfControlPasswordRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "password" in value;
    isInstance = isInstance && "jwt" in value;

    return isInstance;
}

export function ControlPasswordRequestFromJSON(json: any): ControlPasswordRequest {
    return ControlPasswordRequestFromJSONTyped(json, false);
}

export function ControlPasswordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPasswordRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'password': json['password'],
        'u': !exists(json, 'u') ? undefined : json['u'],
        'jwt': json['jwt'],
    };
}

export function ControlPasswordRequestToJSON(value?: ControlPasswordRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'password': value.password,
        'u': value.u,
        'jwt': value.jwt,
    };
}

